import {createFeatureSelector, createSelector} from "@ngrx/store";
import {countriesFeatureKey, CountriesState} from "../reducers/countries.reducer";

const countriesFeatureState = createFeatureSelector<CountriesState>(countriesFeatureKey);

export const getCountries = createSelector(
  countriesFeatureState,
  state => state.countries ?? []
);
